var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191A1A",
    fillRule: "evenodd",
    d: "M12.954 3.75c0-.783-.634-1.417-1.416-1.417h-9.27c-.782 0-1.416.634-1.416 1.417v6.695c0 .782.634 1.416 1.416 1.416h9.27c.782 0 1.416-.634 1.416-1.416V3.75ZM2.268 3.106h9.27c.356 0 .644.288.644.644v5.164l-1.377-1.652a1.416 1.416 0 0 0-2.154-.026l-.797.91-2.208-2.303a1.416 1.416 0 0 0-2.093.053L1.624 8.122V3.75c0-.356.288-.644.644-.644Zm8.405 7.983L8.39 8.706l.842-.962a.644.644 0 0 1 .979.012l1.97 2.365v.324a.644.644 0 0 1-.643.644h-.865ZM5.088 6.378l4.515 4.71H2.268a.644.644 0 0 1-.644-.643V9.3l2.513-2.9a.644.644 0 0 1 .951-.023Zm4.648-.568a.644.644 0 1 0 0-1.288.644.644 0 0 0 0 1.288Z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.e7e499b3a15c326e97d26737ea89b929.svg";
export { ForwardRef as ReactComponent };